(function () {
  'use strict';

  var STAGE_LABELS = ['Next: finishes', 'Next: basin', 'Next: order details', 'Next: review', 'Configuration reviewed'];
  var LAYOUT_LABELS = {
    centre: 'Centre bowl',
    left: 'Left offset bowl',
    right: 'Right offset bowl',
    double: 'Double bowl'
  };

  function money(value) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(value || 0));
  }

  function optionById(list, id) {
    return (list || []).find(function (item) { return String(item.id) === String(id); }) || null;
  }

  function createButton(className, value, title, subtitle, selected) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className + (selected ? ' is-selected' : '');
    button.dataset.value = String(value);
    button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    button.innerHTML = '<strong>' + title + '</strong>' + (subtitle ? '<small>' + subtitle + '</small>' : '');
    return button;
  }

  function init(root) {
    if (!window.ADPEliConfiguratorData || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    document.body.classList.add('adp-eli-product');

    var data = window.ADPEliConfiguratorData;
    var productScope = root.closest('.productView-details') || root.parentElement;
    var shopifyVariants = JSON.parse(root.querySelector('[data-adp-eli-shopify-variants]').textContent);
    var state = {
      step: 0,
      configuration_name: '',
      mounting: 'wall-hung',
      width: 600,
      custom_width: null,
      layout: 'centre',
      top_mode: 'standard-top',
      cabinet_finish: null,
      top_material: '20mm Cherry Pie',
      top_finish: null,
      basin: null,
      tap_hole: null,
      tap_hole_left: null,
      tap_hole_right: null,
      power_location: null,
      customer_notes: '',
      splashback_height: null,
      requested_depth: 'full-depth',
      filler_left: 'none',
      filler_right: 'none',
      infill_left_width: null,
      infill_right_width: null,
      waste: null,
      power_point: null,
      statement_top: null,
      wall_condition: 'freestanding',
      quantity: 1,
      confirmed: false
    };

    var refs = {
      stages: Array.prototype.slice.call(root.querySelectorAll('[data-stage]')),
      progress: Array.prototype.slice.call(root.querySelectorAll('[data-progress]')),
      back: root.querySelector('[data-back]'),
      next: root.querySelector('[data-next]'),
      validation: root.querySelector('[data-validation]'),
      review: root.querySelector('[data-review]'),
      total: root.querySelector('[data-estimated-total]'),
      livePrice: root.querySelector('[data-live-price]'),
      livePricePanel: root.querySelector('.adp-eli__live-price'),
      livePriceBreakdown: root.querySelector('[data-live-price-breakdown]'),
      livePriceStatus: root.querySelector('[data-live-price-status]'),
      quantityInput: root.querySelector('[data-field="quantity"]'),
      quantityMinus: root.querySelector('[data-quantity-minus]'),
      quantityPlus: root.querySelector('[data-quantity-plus]'),
      configurationName: root.querySelector('[data-field="configuration_name"]'),
      checkoutMessage: root.querySelector('[data-checkout-message]'),
      quoteAction: root.querySelector('[data-quote-action]'),
      anotherConfiguration: root.querySelector('[data-another-configuration]'),
      confirmation: root.querySelector('[data-order-confirmation]'),
      cabinetSearch: root.querySelector('[data-search="cabinet"]'),
      topSearch: root.querySelector('[data-search="top"]'),
      basinSearch: root.querySelector('[data-search="basin"]'),
      cabinetGrid: root.querySelector('[data-grid="cabinet"]'),
      topGrid: root.querySelector('[data-grid="top"]'),
      basinGrid: root.querySelector('[data-grid="basin"]'),
      topMaterial: root.querySelector('[data-field="top_material"]'),
      topGroup: root.querySelector('[data-top-finish-group]'),
      topHint: root.querySelector('[data-top-hint]'),
      customToggle: root.querySelector('[data-custom-width-toggle]'),
      customField: root.querySelector('[data-custom-width-field]'),
      customInput: root.querySelector('[data-field="custom_width"]'),
      noBasin: root.querySelector('[data-no-basin]'),
      tapHoleGroup: root.querySelector('[data-tap-hole-group]'),
      wasteGroup: root.querySelector('[data-waste-group]'),
      statementTopGroup: root.querySelector('[data-statement-top-group]')
    };

    function key() {
      return state.mounting + ':' + state.width;
    }

    function availableOn(item) {
      return (!item.available_on || item.available_on.indexOf(key()) !== -1) &&
        (!item.required_material || item.required_material === state.top_material) && !item.out_of_stock;
    }

    function currentDataVariant() {
      if (state.custom_width) return null;
      return data.variants.find(function (variant) {
        return variant.mounting === state.mounting &&
          Number(variant.width) === Number(state.width) &&
          variant.layout === state.layout &&
          variant.top_mode === state.top_mode;
      }) || null;
    }

    function currentShopifyVariant() {
      var desired = currentDataVariant();
      if (!desired) return null;
      return shopifyVariants.find(function (variant) {
        return variant.sku === desired.sku;
      }) || null;
    }

    function basinCount() {
      return state.layout === 'double' ? 2 : 1;
    }

    function selectedTop() { return optionById(data.top_finishes, state.top_finish); }
    function selectedCabinet() { return optionById(data.cabinet_finishes, state.cabinet_finish); }
    function selectedBasin() { return optionById(data.basins, state.basin); }
    function selectedWaste() { return optionById(data.wastes, state.waste); }
    function selectedPower() { return optionById(data.power_points, state.power_point); }
    function selectedStatementTop() { return optionById(data.statement_tops, state.statement_top); }
    function selectedTapHole() { return optionById(data.tap_holes, state.tap_hole); }
    function selectedTapHoleSide(side) { return optionById(data.tap_holes, state['tap_hole_' + side]); }
    function tapHoleSummary() {
      if (state.top_mode === 'cabinet-only') return 'Not applicable';
      if (state.layout === 'double') {
        var left = selectedTapHoleSide('left');
        var right = selectedTapHoleSide('right');
        return 'Left basin: ' + (left ? left.name : 'Not selected') + ' · Right basin: ' + (right ? right.name : 'Not selected');
      }
      return selectedTapHole() ? selectedTapHole().name : 'Not selected';
    }
    function selectedWall() { return optionById(data.wall_conditions, state.wall_condition); }

    function priceBreakdown() {
      var base = currentDataVariant() ? Number(currentDataVariant().price) : 0;
      var top = selectedTop();
      var basin = selectedBasin();
      var waste = selectedWaste();
      var power = selectedPower();
      var statement = state.top_mode === 'standard-top' ? selectedStatementTop() : null;
      var topSurcharge = state.top_mode === 'standard-top' && top && top.adjustment_percent ? base * Number(top.adjustment_percent) / 100 : 0;
      var basinPrice = basin ? Number(basin.price || 0) * basinCount() : 0;
      var wastePrice = waste ? Number(waste.price || 0) * basinCount() : 0;
      return {
        base: base,
        top: topSurcharge,
        basin: basinPrice,
        waste: wastePrice,
        power: power ? Number(power.price || 0) : 0,
        statement: statement ? Number(statement.price || 0) : 0,
        total: base + topSurcharge + basinPrice + wastePrice + (power ? Number(power.price || 0) : 0) + (statement ? Number(statement.price || 0) : 0)
      };
    }

    function quoteReasons() {
      var price = priceBreakdown();
      var wall = selectedWall();
      var reasons = [];
      if (state.custom_width) reasons.push('custom width');
      if (state.requested_depth === 'ensuite') reasons.push('Ensuite depth quotation');
      if (state.splashback_height) reasons.push('splashback');
      if (state.filler_left !== 'none' || state.filler_right !== 'none') reasons.push('filler / infill');
      var shopifyBase = currentShopifyVariant();
      if (shopifyBase && Math.abs(Number(shopifyBase.price) - price.base) > 0.01) reasons.push('supplier price differs from store base');
      if (selectedBasin() && selectedBasin().out_of_stock) reasons.push('basin availability');
      if (price.top > 0) reasons.push('percentage benchtop surcharge');
      if (price.basin > 0) reasons.push('basin add-on');
      if (price.waste > 0) reasons.push('waste finish add-on');
      if (price.power > 0) reasons.push('power point add-on');
      if (price.statement > 0) reasons.push('statement benchtop upgrade');
      if (wall && wall.quote_only) reasons.push('wall infill/filler');
      return reasons;
    }

    function renderChoiceGroup(name, options) {
      var container = root.querySelector('[data-choice-group="' + name + '"]');
      container.innerHTML = '';
      options.forEach(function (option) {
        var button = createButton('adp-eli__choice', option.value, option.title, option.subtitle, String(state[name]) === String(option.value));
        button.addEventListener('click', function () {
          state[name] = option.value;
          if (name === 'width') {
            state.custom_width = null;
            refs.customField.hidden = true;
            refs.customToggle.classList.remove('is-selected');
            resetDependentSelections();
          }
          if (name === 'mounting' || name === 'layout' || name === 'top_mode') resetDependentSelections();
          render();
        });
        container.appendChild(button);
      });
    }

    function resetDependentSelections() {
      var layouts = data.rules.layouts_by_width[String(state.width)] || ['centre'];
      if (layouts.indexOf(state.layout) === -1) state.layout = layouts[0];
      if (selectedCabinet() && !availableOn(selectedCabinet())) state.cabinet_finish = null;
      if (selectedTop() && !availableOn(selectedTop())) state.top_finish = null;
      if (selectedBasin() && !availableOn(selectedBasin())) state.basin = null;
      if (selectedWaste() && !availableOn(selectedWaste())) state.waste = null;
      if (selectedStatementTop() && !availableOn(selectedStatementTop())) state.statement_top = null;
      if (state.layout === 'double') {
        if (state.tap_hole && !state.tap_hole_left) state.tap_hole_left = state.tap_hole;
        if (state.tap_hole && !state.tap_hole_right) state.tap_hole_right = state.tap_hole;
        state.tap_hole = null;
      } else {
        if (!state.tap_hole && state.tap_hole_left && state.tap_hole_left === state.tap_hole_right) state.tap_hole = state.tap_hole_left;
        state.tap_hole_left = null;
        state.tap_hole_right = null;
      }
      if (state.top_mode === 'cabinet-only') {
        state.top_finish = null;
        state.statement_top = null;
        state.tap_hole = null;
        state.tap_hole_left = null;
        state.tap_hole_right = null;
        state.splashback_height = null;
      }
      state.confirmed = false;
      refs.confirmation.checked = false;
    }

    function renderBaseChoices() {
      renderChoiceGroup('mounting', [
        { value: 'wall-hung', title: 'Wall hung', subtitle: '570mm high × 500mm deep' },
        { value: 'floor-mount', title: 'Floor mount', subtitle: '900mm high × 500mm deep' }
      ]);
      renderChoiceGroup('width', data.widths.map(function (width) {
        return { value: width, title: width + 'mm', subtitle: width + 'W × ' + data.rules.dimensions[state.mounting].height + 'H × 500D' };
      }));
      renderChoiceGroup('layout', (data.rules.layouts_by_width[String(state.width)] || []).map(function (layout) {
        return { value: layout, title: LAYOUT_LABELS[layout], subtitle: layout === 'double' ? 'Two matching basins' : 'One basin position' };
      }));
      renderChoiceGroup('top_mode', [
        { value: 'standard-top', title: 'With benchtop', subtitle: 'Choose an ADP top finish' },
        { value: 'cabinet-only', title: 'Cabinet only', subtitle: 'No benchtop supplied' }
      ]);
    }

    function renderSwatches(items, grid, selectedId, search, type) {
      var term = String(search || '').trim().toLowerCase();
      var filtered = items.filter(availableOn).filter(function (item) {
        return !term || (item.name + ' ' + (item.material || '')).toLowerCase().indexOf(term) !== -1;
      });
      grid.innerHTML = '';
      filtered.forEach(function (item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'adp-eli__swatch' + (String(selectedId) === String(item.id) ? ' is-selected' : '');
        button.dataset.value = item.id;
        button.setAttribute('aria-pressed', String(selectedId) === String(item.id) ? 'true' : 'false');
        button.innerHTML = (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') + '<span>' + item.name + '</span>';
        button.addEventListener('click', function () {
          if (type === 'cabinet') state.cabinet_finish = item.id;
          else state.top_finish = item.id;
          state.confirmed = false;
          refs.confirmation.checked = false;
          render();
        });
        grid.appendChild(button);
      });
    }

    function renderFinishes() {
      renderSwatches(data.cabinet_finishes, refs.cabinetGrid, state.cabinet_finish, refs.cabinetSearch.value, 'cabinet');
      refs.topGroup.hidden = state.top_mode === 'cabinet-only';
      if (state.top_mode === 'cabinet-only') return;
      var materials = data.top_finishes.map(function (item) { return item.material; }).filter(function (value, index, array) { return array.indexOf(value) === index; });
      if (materials.indexOf(state.top_material) === -1) state.top_material = materials[0];
      refs.topMaterial.innerHTML = materials.map(function (material) {
        return '<option value="' + material + '"' + (material === state.top_material ? ' selected' : '') + '>' + material + '</option>';
      }).join('');
      var materialItems = data.top_finishes.filter(function (item) { return item.material === state.top_material; });
      if (selectedTop() && selectedTop().material !== state.top_material) state.top_finish = null;
      renderSwatches(materialItems, refs.topGrid, state.top_finish, refs.topSearch.value, 'top');
      refs.topHint.textContent = state.top_material === '20mm Caesarstone Mineral'
        ? 'ADP applies a 25% surcharge after the base cabinet price. This configuration requires final confirmation.'
        : 'This material is included in the selected standard-top base price.';
      refs.topHint.classList.toggle('is-warning', state.top_material === '20mm Caesarstone Mineral');
    }

    function renderBasins() {
      var term = refs.basinSearch.value.trim().toLowerCase();
      var items = data.basins.filter(availableOn).filter(function (item) {
        return !term || (item.name + ' ' + item.sku).toLowerCase().indexOf(term) !== -1;
      });
      if (!term) {
        var selected = selectedBasin();
        items = items.slice(0, 24);
        if (selected && items.indexOf(selected) === -1) items.unshift(selected);
      }
      refs.basinGrid.innerHTML = '';
      items.forEach(function (item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'adp-eli__basin-card' + (String(state.basin) === String(item.id) ? ' is-selected' : '');
        button.setAttribute('aria-pressed', String(state.basin) === String(item.id) ? 'true' : 'false');
        button.innerHTML = (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
          '<span>' + item.name + '</span><span class="adp-eli__price-add">+' + money(Number(item.price) * basinCount()) + (basinCount() === 2 ? ' for 2' : '') + '</span>';
        button.addEventListener('click', function () {
          state.basin = item.id;
          refs.noBasin.classList.remove('is-selected');
          state.confirmed = false;
          refs.confirmation.checked = false;
          render();
        });
        refs.basinGrid.appendChild(button);
      });
      refs.noBasin.classList.toggle('is-selected', !state.basin);
      refs.noBasin.setAttribute('aria-pressed', !state.basin ? 'true' : 'false');
    }

    function fillSelect(element, items, selected, noneLabel, priceMultiplier) {
      var html = noneLabel ? '<option value="">' + noneLabel + '</option>' : '';
      html += items.filter(availableOn).map(function (item) {
        var price = Number(item.price || 0) * (item.multiply_by_basin_count ? priceMultiplier : 1);
        return '<option value="' + item.id + '"' + (String(selected) === String(item.id) ? ' selected' : '') + '>' + item.name + (price ? ' (+' + money(price) + ')' : '') + '</option>';
      }).join('');
      element.innerHTML = html;
    }

    function renderDetails() {
      var tap = root.querySelector('[data-field="tap_hole"]');
      tap.innerHTML = '<option value="">Choose tap-hole drilling</option>' + data.tap_holes.map(function (item) { return '<option value="' + item.id + '"' + (item.id === state.tap_hole ? ' selected' : '') + '>' + item.name + '</option>'; }).join('');
      var waste = root.querySelector('[data-field="waste"]');
      fillSelect(waste, data.wastes, state.waste, 'Choose plug & waste', basinCount());
      fillSelect(root.querySelector('[data-field="power_point"]'), data.power_points, state.power_point, 'No in-drawer power point', 1);
      fillSelect(root.querySelector('[data-field="statement_top"]'), data.statement_tops, state.statement_top, 'Standard benchtop thickness', 1);
      root.querySelector('[data-field="wall_condition"]').innerHTML = data.wall_conditions.map(function (item) { return '<option value="' + item.id + '"' + (item.id === state.wall_condition ? ' selected' : '') + '>' + item.name + '</option>'; }).join('');
      refs.tapHoleGroup.hidden = state.top_mode === 'cabinet-only' || state.layout === 'double';
      refs.statementTopGroup.hidden = state.top_mode === 'cabinet-only';
      refs.wasteGroup.hidden = false;
    }

    function selectionProperties() {
      var variant = currentDataVariant();
      var price = priceBreakdown();
      function filler(side) {
        var kind = state['filler_' + side];
        var names = {none:'None',filler:'Filler; cabinet unchanged; installer trims on site','infill-10':'Infill; reduce cabinet by 10 mm','wide-infill':'Wide infill; cabinet adjusted to suit'};
        return (names[kind] || kind) + (kind === 'wide-infill' ? '; ' + (state['infill_' + side + '_width'] ? state['infill_' + side + '_width'] + ' mm' : 'width to confirm (60–100 mm)') : '');
      }
      function basinColour(basin) {
        if (!basin) return '';
        var colours = ['Gloss White', 'Matte White', 'Matte Ivory', 'Matte Concrete', 'Matte Olive', 'Matte Forest', 'Matte Black', 'Matte Pearl', 'Royal Beige', 'Cape Verde', 'Manyana', 'Butter', 'Charcoal', 'Plum', 'Sea Salt', 'Travertine', 'Black/White'];
        return colours.find(function (colour) { return basin.name.indexOf(colour) !== -1; }) || 'Confirm with ADP';
      }
      return {
        'Configuration Name': state.configuration_name || 'Not named',
        'ADP Base SKU': state.requested_depth === 'ensuite' ? 'ENSUITE - QUOTE REQUIRED' : (variant ? variant.sku : 'CUSTOM WIDTH - QUOTE'),
        'Depth': state.requested_depth === 'ensuite' ? 'Ensuite - 395 mm; supplier quote required' : 'Full Depth - 500 mm',
        'Quantity': state.quantity,
        'Mounting': state.mounting === 'wall-hung' ? 'Wall Hung' : 'Floor Mount',
        'Overall Width': (state.custom_width || state.width) + ' mm',
        'Bowl Layout': LAYOUT_LABELS[state.layout],
        'Benchtop Supply': state.top_mode === 'standard-top' ? 'With Benchtop' : 'Cabinet Only - No Benchtop',
        'Cabinet Finish': selectedCabinet() ? selectedCabinet().name : 'Not selected',
        'Benchtop Finish': state.top_mode === 'cabinet-only' ? 'Not supplied' : (selectedTop() ? selectedTop().material + ' - ' + selectedTop().name : 'Not selected'),
        'Basin Name': selectedBasin() ? basinCount() + ' × ' + selectedBasin().name : 'No basin supplied',
        'Basin Code': selectedBasin() ? selectedBasin().sku : 'Not applicable',
        'Basin Colour': selectedBasin() ? basinColour(selectedBasin()) : 'Not applicable',
        'Tap Holes': tapHoleSummary(),
        'Plug and Waste': selectedWaste() ? basinCount() + ' × ' + selectedWaste().name : 'Not selected',
        'Power Point': selectedPower() ? selectedPower().name : 'None',
        'Power Point Location': selectedPower() ? (state.power_location || 'Not selected') + ' drawer; ' + (state.mounting === 'wall-hung' ? 'bottom drawer' : 'top drawer') : 'Not applicable',
        'Splashback': state.splashback_height ? state.splashback_height + ' mm - quote required' : 'None',
        'Left Filler / Infill': filler('left'),
        'Right Filler / Infill': filler('right'),
        'Benchtop Upgrade': state.top_mode === 'cabinet-only' ? 'Not applicable' : (selectedStatementTop() ? selectedStatementTop().name : 'Standard thickness'),
        'Wall Condition': state.filler_left !== 'none' || state.filler_right !== 'none' ? 'See selected left / right filler and infill details' : (selectedWall() ? selectedWall().name : 'Not selected'),
        'Customer Notes': state.customer_notes || 'None',
        '_ADP Estimated Total': state.custom_width || state.requested_depth === 'ensuite' ? 'Quotation required' : money(price.total * state.quantity) + (state.splashback_height || state.filler_left !== 'none' || state.filler_right !== 'none' ? ' + unpriced installation extras' : ''),
        '_ADP Estimate Checked': data.source_retrieved_at
      };
    }

    function addPropertiesToForms() {
      var properties = selectionProperties();
      Array.prototype.slice.call(productScope.querySelectorAll('form[action*="/cart/add"]')).forEach(function (form) {
        Array.prototype.slice.call(form.querySelectorAll('[data-adp-eli-property]')).forEach(function (node) { node.remove(); });
        Object.keys(properties).forEach(function (name) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          input.value = properties[name];
          input.dataset.adpEliProperty = 'true';
          form.appendChild(input);
        });
      });
    }

    function syncQuantityToForms() {
      Array.prototype.slice.call(productScope.querySelectorAll('form[action*="/cart/add"]')).forEach(function (form) {
        var input = form.querySelector('input[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
        }
        input.value = state.quantity;
      });
    }

    function syncNativeVariant() {
      var desired = currentDataVariant();
      var shopify = currentShopifyVariant();
      if (!desired || !shopify) return;
      function choose(name, value) {
        var input = Array.prototype.slice.call(productScope.querySelectorAll('input[name="' + name + '"]')).find(function (node) { return node.value === value; });
        if (input && !input.checked) input.click();
      }
      choose('Mounting', desired.option_mounting);
      window.setTimeout(function () {
        choose('Size and Configuration', desired.option_configuration);
        Array.prototype.slice.call(productScope.querySelectorAll('form[action*="/cart/add"] input[name="id"]')).forEach(function (input) {
          input.value = shopify.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        updateNativeButtons();
        window.setTimeout(updateNativeButtons, 250);
      }, 30);
    }

    function renderReview() {
      if (state.step !== 4) return;
      var price = priceBreakdown();
      var props = selectionProperties();
      var priceRows = [
        ['Shopify base configuration', currentDataVariant() ? currentDataVariant().sku + ' × ' + state.quantity : 'Quote only', price.base * state.quantity],
        ['Benchtop surcharge', selectedTop() ? selectedTop().name : '—', price.top * state.quantity],
        ['Basin', selectedBasin() ? basinCount() + ' × ' + selectedBasin().name + ' per vanity' : 'Not supplied', price.basin * state.quantity],
        ['Plug and waste', selectedWaste() && selectedBasin() ? selectedWaste().name : '—', price.waste * state.quantity],
        ['Power point', selectedPower() ? selectedPower().name : 'None', price.power * state.quantity],
        ['Benchtop thickness', selectedStatementTop() ? selectedStatementTop().name : 'Standard', price.statement * state.quantity]
      ];
      var selectionRows = [
        ['Configuration name', props['Configuration Name'], ''],
        ['Quantity', state.quantity + (state.quantity === 1 ? ' vanity' : ' vanities'), ''],
        ['Cabinet', props.Mounting + ' · ' + props['Overall Width'] + ' · ' + props['Bowl Layout'], ''],
        ['Cabinet finish', props['Cabinet Finish'], ''],
        ['Benchtop', props['Benchtop Finish'], ''],
        ['Tap holes', props['Tap Holes'], ''],
        ['Wall condition', props['Wall Condition'], '']
      ];
      refs.review.innerHTML = selectionRows.concat(priceRows).map(function (row) {
        return '<div class="adp-eli__review-row"><span>' + row[0] + '</span><span>' + row[1] + '</span><strong>' + (row[2] ? money(row[2]) : '') + '</strong></div>';
      }).join('');
      refs.total.textContent = state.custom_width || state.requested_depth === 'ensuite' ? 'Quotation required' : money(price.total * state.quantity) + (state.splashback_height || state.filler_left !== 'none' || state.filler_right !== 'none' ? ' + quote-only extras' : '');
      var reasons = quoteReasons();
      refs.checkoutMessage.textContent = reasons.length
        ? 'The displayed total contains items Shopify cannot safely charge as one product yet (' + reasons.join(', ') + '). OZ Bathroom must confirm the final price, freight and compatibility before checkout.'
        : 'This selection has no paid add-ons. After acknowledging the made-to-order terms, the exact base SKU can be added to cart.';
      refs.checkoutMessage.classList.toggle('is-warning', reasons.length > 0);
      refs.quoteAction.classList.toggle('is-visible', reasons.length > 0);
    }

    function renderLivePrice() {
      var price = priceBreakdown();
      var extras = price.total - price.base;
      var reasons = quoteReasons();
      if (state.custom_width || state.requested_depth === 'ensuite') {
        refs.livePrice.textContent = 'Quotation required';
        refs.livePriceBreakdown.textContent = state.requested_depth === 'ensuite' ? 'Ensuite depth - supplier quotation required' : state.custom_width + 'mm custom-width cabinet';
        refs.livePriceStatus.textContent = 'Final ADP price and fit must be confirmed';
        refs.livePricePanel.classList.add('is-quote');
        return;
      }
      refs.livePrice.textContent = money(price.total * state.quantity);
      if (state.splashback_height || state.filler_left !== 'none' || state.filler_right !== 'none') refs.livePrice.textContent += ' + quote-only extras';
      refs.livePriceBreakdown.textContent = state.quantity > 1
        ? state.quantity + ' configured vanities × ' + money(price.total) + ' each'
        : 'Base ' + money(price.base) + (extras > 0 ? ' + selected extras ' + money(extras) : ' · no priced extras selected');
      refs.livePriceStatus.textContent = reasons.length
        ? 'Live ADP estimate · final order price to be confirmed'
        : 'Exact Shopify base configuration';
      refs.livePricePanel.classList.toggle('is-quote', reasons.length > 0);
    }

    function validateStage() {
      if (state.step === 0 && !state.configuration_name) return 'Give this bathroom configuration a name before continuing.';
      if (state.step === 0 && !currentDataVariant() && !state.custom_width) return 'Please choose a valid cabinet combination.';
      if (state.step === 0 && state.custom_width && (state.custom_width < data.custom_width.min || state.custom_width > data.custom_width.max)) return 'Custom width must be between 540 and 1800mm.';
      if (state.step === 1 && !state.cabinet_finish) return 'Choose a cabinet finish.';
      if (state.step === 1 && state.top_mode === 'standard-top' && !state.top_finish) return 'Choose a benchtop finish.';
      return '';
    }

    function updateNativeButtons() {
      var reasons = quoteReasons();
      var canCart = state.step === 4 && state.confirmed && reasons.length === 0 && !!currentShopifyVariant();
      Array.prototype.slice.call(productScope.querySelectorAll('button[name="add"], #product-add-to-cart')).forEach(function (button) {
        if (!button.dataset.adpEliOriginalText) button.dataset.adpEliOriginalText = button.textContent.trim();
        button.disabled = !canCart;
        button.setAttribute('aria-disabled', canCart ? 'false' : 'true');
        button.textContent = canCart ? 'Add configured Eli to cart' : (reasons.length ? 'Final quote required before purchase' : 'Complete configuration above');
      });
      Array.prototype.slice.call(productScope.querySelectorAll('.shopify-payment-button')).forEach(function (node) { node.style.display = 'none'; });
    }

    function renderStage() {
      refs.stages.forEach(function (stage, index) { stage.classList.toggle('is-active', index === state.step); });
      refs.progress.forEach(function (item, index) {
        item.classList.toggle('is-active', index === state.step);
        item.classList.toggle('is-complete', index < state.step);
      });
      refs.back.disabled = state.step === 0;
      refs.next.textContent = STAGE_LABELS[state.step];
      refs.next.disabled = state.step === 4;
    }

    function render() {
      renderBaseChoices();
      renderFinishes();
      renderBasins();
      renderDetails();
      renderStage();
      renderLivePrice();
      renderReview();
      syncNativeVariant();
      addPropertiesToForms();
      syncQuantityToForms();
      updateNativeButtons();
      document.dispatchEvent(new CustomEvent('adp-eli:configuration-change', {
        detail: {
          mounting: state.mounting,
          width: state.custom_width || state.width,
          layout: state.layout,
          cabinetFinish: selectedCabinet(),
          topFinish: selectedTop()
        }
      }));
    }

    refs.customToggle.addEventListener('click', function () {
      if (state.custom_width) {
        state.custom_width = null;
        refs.customField.hidden = true;
      } else {
        state.custom_width = Number(refs.customInput.value || state.width);
        refs.customInput.value = state.custom_width;
        refs.customField.hidden = false;
      }
      refs.customToggle.classList.toggle('is-selected', !!state.custom_width);
      state.confirmed = false;
      refs.confirmation.checked = false;
      render();
    });
    refs.customInput.addEventListener('input', function () { state.custom_width = Number(this.value); state.confirmed = false; refs.confirmation.checked = false; renderLivePrice(); renderReview(); updateNativeButtons(); });
    refs.configurationName.addEventListener('input', function () {
      state.configuration_name = this.value.trim();
      state.confirmed = false;
      refs.confirmation.checked = false;
      refs.validation.textContent = '';
      renderReview();
      addPropertiesToForms();
      updateNativeButtons();
    });
    function updateQuantity(value) {
      state.quantity = Math.max(1, Math.min(99, parseInt(value, 10) || 1));
      refs.quantityInput.value = state.quantity;
      state.confirmed = false;
      refs.confirmation.checked = false;
      renderLivePrice();
      renderReview();
      addPropertiesToForms();
      syncQuantityToForms();
      updateNativeButtons();
    }
    refs.quantityMinus.addEventListener('click', function () { updateQuantity(state.quantity - 1); });
    refs.quantityPlus.addEventListener('click', function () { updateQuantity(state.quantity + 1); });
    refs.quantityInput.addEventListener('input', function () { if (this.value !== '') updateQuantity(this.value); });
    refs.quantityInput.addEventListener('change', function () { updateQuantity(this.value); });
    refs.cabinetSearch.addEventListener('input', renderFinishes);
    refs.topSearch.addEventListener('input', renderFinishes);
    refs.basinSearch.addEventListener('input', renderBasins);
    refs.topMaterial.addEventListener('change', function () { state.top_material = this.value; state.top_finish = null; resetDependentSelections(); render(); });
    refs.noBasin.addEventListener('click', function () { state.basin = null; state.confirmed = false; refs.confirmation.checked = false; render(); });
    root.querySelector('[data-field="tap_hole"]').addEventListener('change', function () { state.tap_hole = this.value; render(); });
    root.querySelector('[data-field="waste"]').addEventListener('change', function () { state.waste = this.value; state.confirmed = false; refs.confirmation.checked = false; render(); });
    root.querySelector('[data-field="power_point"]').addEventListener('change', function () { state.power_point = this.value || null; state.confirmed = false; refs.confirmation.checked = false; render(); });
    root.querySelector('[data-field="statement_top"]').addEventListener('change', function () { state.statement_top = this.value || null; state.confirmed = false; refs.confirmation.checked = false; render(); });
    root.querySelector('[data-field="wall_condition"]').addEventListener('change', function () { state.wall_condition = this.value; state.confirmed = false; refs.confirmation.checked = false; render(); });
    refs.confirmation.addEventListener('change', function () { state.confirmed = this.checked; updateNativeButtons(); });
    refs.back.addEventListener('click', function () { if (state.step > 0) { state.step -= 1; refs.validation.textContent = ''; render(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    refs.next.addEventListener('click', function () {
      var error = validateStage();
      refs.validation.textContent = error;
      if (error) return;
      if (state.step < 4) state.step += 1;
      render();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    refs.quoteAction.addEventListener('click', function () {
      var summary = Object.keys(selectionProperties()).map(function (name) { return name + ': ' + selectionProperties()[name]; }).join('\n');
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(summary).catch(function () {});
      var enquiry = document.getElementById('enquiryNowBtn');
      if (enquiry) enquiry.click();
      refs.validation.textContent = 'Configuration copied. Paste it into the enquiry message so OZ Bathroom can confirm the order.';
    });
    refs.anotherConfiguration.addEventListener('click', function () {
      Object.assign(state, {
        step: 0,
        configuration_name: '',
        mounting: 'wall-hung',
        width: 600,
        custom_width: null,
        layout: 'centre',
        top_mode: 'standard-top',
        cabinet_finish: null,
        top_material: '20mm Cherry Pie',
        top_finish: null,
        basin: null,
        tap_hole: null,
        tap_hole_left: null,
        tap_hole_right: null,
        power_location: null,
        customer_notes: '',
        splashback_height: null,
        requested_depth: 'full-depth',
        filler_left: 'none',
        filler_right: 'none',
        infill_left_width: null,
        infill_right_width: null,
        waste: null,
        power_point: null,
        statement_top: null,
        wall_condition: 'freestanding',
        quantity: 1,
        confirmed: false
      });
      refs.configurationName.value = '';
      refs.quantityInput.value = 1;
      refs.cabinetSearch.value = '';
      refs.topSearch.value = '';
      refs.basinSearch.value = '';
      refs.customInput.value = state.width;
      refs.customField.hidden = true;
      refs.confirmation.checked = false;
      refs.validation.textContent = '';
      render();
      refs.configurationName.focus();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Local-language bridge: validate a whole proposal before changing the existing state.
    // Pricing, exact SKU selection, enquiry and order confirmation remain owned by this engine.
    root.adpEliApplyRequirements = function (values) {
      var problems = [];
      var allowed = ['mounting', 'width', 'layout', 'top_mode', 'cabinet_finish', 'top_material', 'top_finish', 'basin', 'tap_hole', 'tap_hole_left', 'tap_hole_right', 'waste', 'power_point', 'statement_top', 'wall_condition', 'quantity', 'configuration_name', 'custom_width', 'requested_depth', 'power_location', 'customer_notes', 'splashback_height', 'filler_left', 'filler_right', 'infill_left_width', 'infill_right_width'];
      if (!values || typeof values !== 'object' || Object.keys(values).some(function (k) { return allowed.indexOf(k) === -1; })) return {ok:false, errors:['Unsupported configuration field.']};
      var proposed = Object.assign({}, state, values, {step:0, confirmed:false});
      var base = data.variants.find(function (v) { return v.mounting === proposed.mounting && Number(v.width) === Number(proposed.width) && v.layout === proposed.layout && v.top_mode === proposed.top_mode; });
      if (!base) problems.push('That exact standard base combination is not listed.');
      var key = proposed.mounting + ':' + proposed.width;
      var map = {cabinet_finish:'cabinet_finishes', top_finish:'top_finishes', basin:'basins', waste:'wastes', power_point:'power_points', statement_top:'statement_tops', tap_hole:'tap_holes', tap_hole_left:'tap_holes', tap_hole_right:'tap_holes', wall_condition:'wall_conditions'};
      Object.keys(map).forEach(function (field) {
        if (proposed[field] == null) return;
        var item = optionById(data[map[field]], proposed[field]);
        if (!item || item.out_of_stock || (item.available_on && item.available_on.indexOf(key) === -1)) {
          if (Object.prototype.hasOwnProperty.call(values, field)) problems.push('The requested ' + field.replace(/_/g, ' ') + ' is unavailable for this base.');
          else proposed[field] = null;
        }
      });
      if (!data.top_finishes.some(function (t) { return t.material === proposed.top_material; })) problems.push('Unknown benchtop material.');
      if (proposed.top_finish) {
        var top = optionById(data.top_finishes, proposed.top_finish);
        if (top && top.material !== proposed.top_material) {
          if (Object.prototype.hasOwnProperty.call(values, 'top_finish')) problems.push('Benchtop material and finish do not agree.');
          else proposed.top_finish = null;
        }
      }
      if (proposed.layout === 'double') {
        if (proposed.tap_hole) {
          if (!proposed.tap_hole_left) proposed.tap_hole_left = proposed.tap_hole;
          if (!proposed.tap_hole_right) proposed.tap_hole_right = proposed.tap_hole;
        }
        proposed.tap_hole = null;
      } else {
        proposed.tap_hole_left = null;
        proposed.tap_hole_right = null;
      }
      if (proposed.top_mode === 'cabinet-only') {
        if (values.top_finish || values.statement_top || values.tap_hole || values.tap_hole_left || values.tap_hole_right || values.top_material) problems.push('Cabinet only cannot apply supplied benchtop details.');
        proposed.top_finish = null;
        proposed.statement_top = null;
        proposed.tap_hole = null;
        proposed.tap_hole_left = null;
        proposed.tap_hole_right = null;
        proposed.splashback_height = null;
      }
      var upgrade = optionById(data.statement_tops, proposed.statement_top);
      if (upgrade && upgrade.required_material && upgrade.required_material !== proposed.top_material) {
        if (Object.prototype.hasOwnProperty.call(values, 'statement_top')) problems.push('Royale benchtop is available in Durasein only.');
        else proposed.statement_top = null;
      }
      if (!proposed.power_point) proposed.power_location = null;
      if (proposed.power_location != null && ['left','right'].indexOf(proposed.power_location) === -1) problems.push('Choose the left or right drawer.');
      if (['full-depth','ensuite'].indexOf(proposed.requested_depth) === -1) problems.push('Choose Full Depth or Ensuite.');
      if (proposed.custom_width != null && (!Number.isInteger(Number(proposed.custom_width)) || proposed.custom_width < 540 || proposed.custom_width > 1800)) problems.push('Custom width must be 540–1800 mm.');
      if (proposed.splashback_height != null && (!Number.isInteger(Number(proposed.splashback_height)) || proposed.splashback_height < 90 || proposed.splashback_height > 250)) problems.push('Splashback height must be 90–250 mm.');
      if (typeof proposed.customer_notes !== 'string' || proposed.customer_notes.length > 600) problems.push('Notes must be 600 characters or fewer.');
      ['left','right'].forEach(function (side) {
        var kind = proposed['filler_' + side];
        if (['none','filler','infill-10','wide-infill'].indexOf(kind) === -1) problems.push('Choose a valid filler or infill.');
        var width = proposed['infill_' + side + '_width'];
        if (kind !== 'wide-infill') proposed['infill_' + side + '_width'] = null;
        else if (width != null && (!Number.isInteger(Number(width)) || width < 60 || width > 100)) problems.push('Wide infill must be 60–100 mm.');
      });
      if (!Number.isInteger(Number(proposed.quantity)) || proposed.quantity < 1 || proposed.quantity > 99) problems.push('Quantity must be 1 to 99.');
      if (proposed.configuration_name && (typeof proposed.configuration_name !== 'string' || proposed.configuration_name.length > 60)) problems.push('Use a configuration name up to 60 characters.');
      if (problems.length) return {ok:false, errors:problems};
      Object.assign(state, proposed);
      refs.configurationName.value = state.configuration_name;
      refs.quantityInput.value = state.quantity;
      refs.customField.hidden = true;
      refs.customToggle.classList.remove('is-selected');
      refs.confirmation.checked = false;
      refs.cabinetSearch.value = '';
      refs.topSearch.value = '';
      refs.basinSearch.value = '';
      refs.validation.textContent = '';
      render();
      return {ok:true, errors:[]};
    };

    root.adpEliGetState = function () { return Object.assign({}, state); };
    root.adpEliGetSummary = function () {
      var props = selectionProperties();
      return Object.keys(props).map(function (name) { return name + ': ' + props[name]; }).join('\n');
    };

    render();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-adp-eli-configurator]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
